import useStyles from './styles';

function Input({
  className,
  innerRef,
  onChange,
  onPaste,
  maxLength,
  value,
  onKeyDown,
  ...props
}: InputProps) {
  const classes = useStyles();

  return (
    <input
      ref={innerRef}
      data-testid={props['data-testid']}
      className={`${classes.input} ${className}`}
      maxLength={maxLength}
      onChange={onChange}
      onPaste={onPaste}
      value={value}
      onKeyDown={onKeyDown}
    />
  );
}

export default Input;
